import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { EmployeeDto } from '../../user/userTypes';
import { getQuestionnaire } from '../questionnaireApi';
import NotFoundPage from '../../error/NotFoundPage';
import { withQuestionnaire } from '../../../router/Loaders';
import QuestionnaireComponent from '../../../components/questionnaire/unansweredQuestionnaire/QuestionnaireComponent';

type LocalStyles = 'root';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    textAlign: 'center',
    padding: theme.spacing.unit * 4,
  },
});

interface Props {
  renderSearch: (showSearch: boolean) => void;
  currentEmployee: EmployeeDto;
  questionnaireId: number;
}

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class ExternalActual extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props);
    this.props.renderSearch(false);
  }

  public render() {
    return (
      <>
        {
          withQuestionnaire(
            () => getQuestionnaire(this.props.questionnaireId),
            questionnaire =>
              <QuestionnaireComponent
                questionnaire={questionnaire}
                currentEmployee={this.props.currentEmployee}
                errorPage={<NotFoundPage/>}/>
          )
        }
      </>
    );
  }
}

export default withStyles(localStyles)(ExternalActual);
